import jsPDF        from 'jspdf'
import _ from 'lodash'
import 'jspdf-autotable'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

const localMethods = {

    watch: {

        async 'form_data.task_id'(val)
        {
            if(val)
            {
                await this.start_search()
            }
            this.dinamic_task(val)
        },

        
        async 'form_data.building_id'(val)
        {
            if(this.form_data.task_id)
            {
                await this.start_search()
            }

            if(val)
            {
                this.loader(true)

                let form_data = {
                    type_request: 'building',
                    id: val
                }

                this.form_data.level_id = ''

                const response = await this.post(this.general_rest_api + '/buildings_levels_areas', form_data)
                if(response.status)
                {
                    this.array_options.level_id = response.data
                    if(response.data.length)
                    {
                        notyf.success('Levels avaliable')
                    }
                }
                else
                {
                    this.error_handling(response)
                }
                this.loader()
            }
            else
            {
                this.array_options.level_id = []
                this.form_data.level_id = ''
            }
        },

        async 'form_data.level_id'(val)
        {
            if(this.form_data.task_id)
            {
                await this.start_search()
            }

            if(val)
            {
                this.loader(true)
                this.form_data.area_id = ''

                let form_data = {
                    type_request: 'level',
                    id: val
                }

                const response = await this.post(this.general_rest_api + '/buildings_levels_areas', form_data)
                if(response.status)
                {
                    this.array_options.area_id = response.data
                    if(response.data.length)
                    {
                        notyf.success('Areas avaliable')
                    }
                }
                else
                {
                    this.error_handling(response)
                }
                this.loader()
            }
            else
            {
                this.array_options.area_id = []
                this.form_data.area_id = ''

            }
        },

        async 'form_data.area_id'()
        {
            if(this.form_data.task_id)
            {
                await this.start_search()
            }
        },

        async 'form_data.frequency'()
        {
            await this.start_search()
        },

        async 'form_data.new_task_id'()
        {
            await this.start_search()
        },

        async 'form_data.new_frequency'()
        {
            await this.start_search()
        },

        async 'form_data.hours_work_week'()
        {
            await this.start_search()
        },


    },

    methods: {

        debounceInput:  _.debounce(function (e)  
        {
            this.form_data[e.field] = e.value
        },800),

        async start_search()
        {

            if(!this.form_data.task_id)
            {
                this.notyf.error('No task to find rooms selected')
                return false
            }

            this.loader(true)


            let object = {
                task_id:  this.form_data.task_id,
                building_id: this.form_data.building_id,
                level_id:  this.form_data.level_id,
                area_id:  this.form_data.area_id,
                frequency: this.form_data.frequency,
                new_task_id: this.form_data.new_task_id,
                new_frequency: this.form_data.new_frequency,
                freq_manual: this.freq_manual,
                hours_work_week: this.form_data.hours_work_week
            }
            let response = await this.post(`${this.rest_api}_pagination`, object)

            if(response.status)
            {
                if(response.data.pagination.data.length)
                {
                    this.room_list  = response.data.pagination.data
                    this.totals     = response.data.totals
                    this.ftes       = response.data.ftes
                    this.notyf.success('Rooms available')
                }
                else
                {
                    this.room_list = []
                    this.notyf.error('No rooms available')
                }
            }
            else
            {
                this.error_handling(response)
            }

            this.loader()
        },

        dinamic_task(data_id)
        {
            this.form_data.task_id = data_id

            if(data_id)
            {
                let found = this.array_options.task_id.find(item => item.id === data_id)
                if(found)
                {
                    this.report_root.name = `Forecaster | ${found.name}`

                    if(found.project)
                    {
                        this.form_data.new_frequency = (this.freq_manual) ? '' : this.form_data.new_frequency
                        this.form_data.frequency = (this.freq_manual) ? '' : this.form_data.frequency
                        this.freq_manual = false
                        this.array_options.new_task_id = this.array_options.task_id.filter(item => item.project === true)
                    }
                    else
                    {
                        this.form_data.new_frequency = (this.freq_manual) ? this.form_data.new_frequency : ''
                        this.form_data.frequency = (this.freq_manual) ? this.form_data.frequency : ''
                        this.freq_manual = true
                        this.array_options.new_task_id = this.array_options.task_id.filter(item => item.project === false)
                    }

                    return
                }
            }

            this.report_root.name = `Forecaster`
        },

        async form_submit()
        {
            if(this.room_list.length)
            {
                this.form_data.rooms_id = []
                this.room_list.forEach((prop) => {
                    this.form_data.rooms_id.push(prop.id)
                })
                this.invoke_loader('get')
                let response = await this.post(this.rest_api, this.form_data)
                if(response.status)
                {
                    this.forecasters = response.data.rooms
                    this.revoke_loader('get')
                }
                else
                {
                    this.revoke_loader('get')
                    this.error_handling(response)
                }
            }
            else
            {
                this.form_modal()
            }
        },

        async modify_records()
        {

            if(this.form_data.new_task_id === '')
            {
                notyf.error('Must select a task')
                return false
            }
            
            if(this.freq_manual && this.form_data.new_frequency < 0)
            {
                notyf.error('Forbidden frequency value')
                return false;
            }
            else if(!this.freq_manual && !this.form_data.new_frequency)
            {
                notyf.error('Select a new frequency')
                return false;
            }

            this.loader(true)


                let object = {
                    room_id:            [],
                    daily_task:         this.freq_manual,
                    new_frequency:   this.form_data.new_frequency,
                    freq_manual:       this.freq_manual,
                }

                this.room_list.forEach((prop)=>{
                    if(prop.checked)
                    {
                        object.room_id.push(prop.room_task_id)
                    }
                })
                
                let response = await this.patch(`${this.rest_api}/${this.form_data.new_task_id}`, object)
                if(response.status)
                {
                    this.start_search()
                    notyf.success('Success')
                }
                else
                {
                    this.error_handling(response)
                    this.loader()
                }
            
        },

        cleanup()
        {
            this.form_data.task_id = ''
            this.building_id = ''
            this.array_options.level_id = []
            this.level_id = ''
            this.array_options.area_id = []
            this.area_id = ''
        },

        async radio_filter(event)
        {
            this.loader(true)
            this.room_list = [];
            this.cleanup();
            await this.task_request_api(event.target.value)
            this.loader()
        },

        async task_request_api(value)
        {
            let object = {
                id:             '',
                radio_request:  true,
                level_request:  false,
                area_request:   false,
                room_request:   false,
                value:          value,
            }
            let response = await this.get(`${this.rest_api}/${JSON.stringify(object)}`)
          
            if(response.status)
            {
                object.value === 'project' ? this.freq_manual = false : this.freq_manual = true
                this.form_data.new_frequency = ''
                this.form_data.task_id = ''
                this.form_data.new_task_id = ''
                this.array_options.task_id = response.data.tasks
                this.array_options.new_task_id = []
            }
            else
            {
                this.error_handling(response)
            }
        },

        fill_data(data)
        {
            this.array_options = {
                frequency_id:     data.frequencies,
                building_id:      data.buildings,
                level_id:         [],
                area_id:          [],
                room_id:          [],
                task_id:          [],
                new_task_id:      [],
            }
        },

        selectAllBoxes()
        {
            if(this.room_list.length)
            {
                this.room_list.map((item) => {
                    item.checked = this.select_all
                })
            }
        },

        exportPDF(orientation = 'landscape')
        {   
            let PDF_doc = new jsPDF(orientation , 'pt', 'letter')
  
            PDF_doc.autoTable([this.report_root.name], [],{
                startY: 92,
                rowPageBreak: 'avoid',
                styles: {fontSize: 13},
                headStyles:{
                    valign: 'middle',
                    halign : 'center',
                    fillColor : [245, 245, 245],
                    textColor: [70, 70, 71],
                    fontStyle: 'normal',
                },
                
            })

            const totals = {
                custom_description: "TOTALS",
                sq_ft: this.totals.sq_ft,
                annual_minutes: this.totals.annual_minutes,
                fake_daily_minutes: this.totals.fake_daily_minutes,
                fake_annual_minutes: this.totals.fake_annual_minutes,
                daily_diference: this.totals.daily_diference,
                annual_diference: this.totals.annual_diference,
            }

            const ftes = {
                custom_description: "FTES",
                annual_minutes: this.ftes.annual_minutes,
                fake_annual_minutes: this.ftes.fake_annual_minutes,
                daily_diference: this.ftes.daily_diference,
                annual_diference: this.ftes.annual_diference,
            }

            let room_list_temp = [...this.room_list]
            room_list_temp.push({})
            room_list_temp.push(totals)
            room_list_temp.push(ftes)

            PDF_doc.setTextColor(80)
            PDF_doc.setFontSize(9);
            PDF_doc.text(45, 140, 'Hours Work Week:')
            PDF_doc.text(125, 140, `${this.form_data.hours_work_week ? this.form_data.hours_work_week : 40}`)

            PDF_doc.autoTable(this.headers_report_table, room_list_temp, {
                margin: { top: 100 },
                startY: 150,
                showHead: 'firstPage',
                styles: {
                    cellPadding: {
                        top: 4,
                        right: 1,
                        bottom: 4,
                        left: 1,
                    },  // Set the global font size for the entire table
                },
                columnStyles: {
                    0: { cellWidth: 175 },
                    2: { cellWidth: 45 },
                    4: { cellWidth: 34 },
                    // 5: { minCellWidth: 35 },
                    // 6: { minCellWidth: 43 },
                    7: { cellWidth: 45 },
                    9: { cellWidth: 34 },
                    // 10: { minCellWidth: 35 },
                    // 11: { minCellWidth: 43 },
                },
                willDrawCell: (data) => 
                {
                    const row = data.row.index
                    const all_rows = data.table.body

                    if (row === all_rows.length - 2 || row === all_rows.length - 1) 
                    {
                        PDF_doc.setFont(undefined, 'bold')
                        PDF_doc.setFontSize(8.50);
                    } 
                    else 
                    {
                        PDF_doc.setFontSize(8.50);
                    }
                },
                
            })
  
            // this.printSummary(PDF_doc);
  
           
            PDF_doc = this.addWaterMark(PDF_doc)

            PDF_doc.save(`${this.report_root.name}`)
            
        },

        addWaterMark(doc)
        {
            const total_pages = doc.internal.getNumberOfPages()

            for (let i = 1; i <= total_pages; i++)
            {
                doc.setPage(i)
                doc.addImage("/assets/img/logo.png", 'png', 40, 28, 120, 40)


                doc.setTextColor(150)
                doc.setFontSize(9);
                doc.text(40, doc.internal.pageSize.height - 30, this.report_root.name)
                doc.text(doc.internal.pageSize.width - 80, doc.internal.pageSize.height - 30, `${i} of ${total_pages}`)

                let xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(this.company_name) * doc.internal.getFontSize() / 2); 
                doc.text(xOffset, doc.internal.pageSize.height - 30, this.company_name)
            }

            return doc
        },

    },
    computed: {
        selected()
        {
            const bool = this.room_list.filter(item => item.checked)
            return Boolean(bool.length)
        },
        room_list_computed()
        {
            return this.room_list
            .filter(room => this.form_data.building_id !== '' ? room.building_id === this.form_data.building_id : room)
            .filter(room => this.form_data.level_id !== '' ? room.level_id === this.form_data.level_id : room)
            .filter(room => this.form_data.area_id !== '' ? room.area_id === this.form_data.area_id : room)
            .filter(room => this.form_data.project_task_id !== '' ? room.task_id === this.form_data.project_task_id : room)
        }

    },

    async mounted()
    {
        if(this.hasPermissions(['Budgeting-Forecaster Read']))
        {
            await this.api_request()
            await this.task_request_api('all')
        }
    }

}

export default localMethods